import { render, staticRenderFns } from "./DatasetChartDetail.vue?vue&type=template&id=16cc81ef&scoped=true"
import script from "./DatasetChartDetail.vue?vue&type=script&lang=js"
export * from "./DatasetChartDetail.vue?vue&type=script&lang=js"
import style0 from "./DatasetChartDetail.vue?vue&type=style&index=0&id=16cc81ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16cc81ef",
  null
  
)

export default component.exports